import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Dot = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox={props.BgColor ? "0 0 105 104" : "0 0 20 20"}
            fill={props.color ? props.color : "#ffffff"}
            customColor={props.customColor}
            width={props.size}
            height={props.size}>
            {props.BgColor ? <rect x="0.5" width="104" height="104" rx="50" fill={props.BgColor} /> : null}
                <g id="SVGRepo_bgCarrier" strokeWidth="0"
                    transform="translate(4.7700000000000005,4.7700000000000005), scale(0.47)">
                    <rect x="-1.8" y="-1.8" width="21.60" height="21.60" rx="10.8" fill={props.color ? props.color : "#ffffff"}
                        strokeWidth="0"></rect>
                </g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" stroke="#CCCCCC"
                    strokeWidth="0.10800000000000001"></g>
                <g id="SVGRepo_iconCarrier">
                    <circle cx="9" cy="9" r="4" fill={props.color ? props.color : "#ffffff"} 
                    fillRule={props.color ? props.color : "#ffffff"}></circle>
                </g>
        </SvgStyled>
    );
};

export default Dot;
